import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useChartTable from '@common/utils/useChartTable';
const METRIC = 'cm';
const IMPERIAL = 'inches';
const BodyMeasurements = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const { sizeChart } = props;
    const [currentMetrics, setCurrentMetrics] = useState(window.country == 'US' ? IMPERIAL : METRIC);
    const [countrySize, setCountrySize] = useState();
    const table = useChartTable(sizeChart, setCountrySize);
    const regionNames = useMemo(() => {
        return window.Intl && new Intl.DisplayNames([window.language == 'ch' ? 'zh-Hant' : window.language], { type: 'region', fallback: 'code' });
    }, []);
    const getRegionNames = (countryId) => {
        return regionNames ? regionNames.of(countryId) : countryId;
    };
    const metricLabel = useMemo(() => {
        if (!sizeChart) {
            return '';
        }
        return sizeChart.mannequinGender != 'dog' ? 'sizeguide.uom.kgcm' : 'sizeguide.uom.cm';
    }, [sizeChart]);
    const imperialLabel = useMemo(() => {
        if (!sizeChart) {
            return '';
        }
        return sizeChart.mannequinGender != 'dog' ? 'sizeguide.uom.inchespounds' : 'sizeguide.uom.inches';
    }, [sizeChart]);
    const metricSelector = () => (React.createElement("ul", { className: "switch" },
        React.createElement("li", null,
            React.createElement("button", { type: "button", onClick: () => {
                    setCurrentMetrics(METRIC);
                }, "data-unit-value": "1", className: currentMetrics === METRIC ? 'switch__item selected' : 'switch__item' }, t(metricLabel))),
        React.createElement("li", null,
            React.createElement("button", { type: "button", onClick: () => {
                    setCurrentMetrics(IMPERIAL);
                }, "data-unit-value": "0", className: currentMetrics === IMPERIAL ? 'switch__item selected' : 'switch__item' }, t(imperialLabel)))));
    return (React.createElement("div", { className: "sizechart" },
        !!sizeChart.sizechartdata ? (React.createElement(React.Fragment, null,
            !sizeChart.sizechartdata.hideCountrySelector && (React.createElement("div", { className: "form-group country-select" },
                React.createElement("label", { className: "form-group__label", htmlFor: "country" }, t('label.country')),
                React.createElement("div", { className: "form-select mb-12" },
                    React.createElement("select", { name: "country", value: countrySize === null || countrySize === void 0 ? void 0 : countrySize.id, onChange: (e) => {
                            setCountrySize(sizeChart.sizechartdata.countries.find((c) => c.id == e.target.value));
                        } }, sizeChart.sizechartdata.countries
                        .filter((c) => c.id != 'MONCLER')
                        .map((c, i) => (React.createElement("option", { key: i, value: c.id }, c.id.length == 2 ? getRegionNames(c.id) : c.id))))))),
            React.createElement("p", { className: "primary-xs" }, t('sizechart.bodymeasurements')),
            React.createElement("div", { className: "custom-table" },
                React.createElement("div", { className: "column fixed-col" },
                    React.createElement("span", { className: "text-uppercase primary-xs" }, t('sizechart.monclersize')),
                    sizeChart.sizechartdata.countries
                        .find((c) => c.id == 'MONCLER')
                        .values.map((s, i) => (React.createElement("span", { className: "primary-xs", key: i }, s)))),
                React.createElement("div", { className: "scrollable-area" },
                    countrySize && (React.createElement("div", { className: "column" },
                        React.createElement("span", { className: "text-uppercase primary-xs" }, (countrySize === null || countrySize === void 0 ? void 0 : countrySize.id.length) == 2 ? getRegionNames(countrySize === null || countrySize === void 0 ? void 0 : countrySize.id) : countrySize === null || countrySize === void 0 ? void 0 : countrySize.id), countrySize === null || countrySize === void 0 ? void 0 :
                        countrySize.values.map((s, i) => (React.createElement("span", { className: "primary-xs", key: i }, s))))),
                    Object.keys(sizeChart.sizechartdata.labelsOnImage).map((c, i) => {
                        return (React.createElement("div", { key: i, className: "column" },
                            React.createElement("span", { className: "text-uppercase primary-xs" }, t(sizeChart.sizechartdata.labelsOnImage[c])),
                            sizeChart.sizechartdata.countries
                                .find((c) => c.id == 'MONCLER')
                                .values.map((s, i) => {
                                if (sizeChart.sizechartdata.sizes[s]) {
                                    return (React.createElement("span", { className: "primary-xs", key: i },
                                        sizeChart.sizechartdata.sizes[s][c][currentMetrics],
                                        ' '));
                                }
                            })));
                    }))))) : (table && (React.createElement("table", { className: "table" },
            React.createElement("thead", null,
                React.createElement("tr", null, (_a = table[currentMetrics]) === null || _a === void 0 ? void 0 : _a[0].map((h, i) => (React.createElement("th", { key: i }, h))))),
            React.createElement("tbody", null, (_b = table[currentMetrics]) === null || _b === void 0 ? void 0 : _b.map((row, rowI) => {
                if (rowI === 0) {
                    return;
                }
                return (React.createElement("tr", { key: rowI }, row.map((item, itemI) => (React.createElement("td", { key: itemI }, item)))));
            }))))),
        (!!sizeChart.content || (!!sizeChart.sizechartdata && !!sizeChart.sizechartdata.sizes && typeof Object.values(sizeChart.sizechartdata.sizes)[0] !== 'string')) && (React.createElement("div", { className: "sizechart__filters" }, metricSelector()))));
};
export default BodyMeasurements;
